import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Card, Col, Container, Row } from "react-bootstrap";
import { FaCamera } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { Link, useParams } from "react-router-dom";
import Footer from "../../components/Footer";
import "../../components/assets/css/slider.css";

import Header from "../../components/Header";
import { listCategory } from "../../functions/ProductDetails/Category";
import { listCategoryProducts } from "../../functions/ProductDetails/ProductCategory";
import {
  GetWhishlistUser,
  RemoveFromWhislist,
} from "../../functions/Prospect/Prsopect";
const WIshList = () => {
  const params = useParams();
  const ProductID = params.productid;
  const CategoryID = params.selectCategActive;

  const [categPro, setCategPro] = useState([]);
  const [categ, setCateg] = useState([]);

  const [WishlistList, setWishlistList] = useState([]);

  useEffect(() => {
    const userid = localStorage.getItem("RegisterUserID");

    GetWhishlistUser(userid)
      .then((res) => {
        setWishlistList(res.data);
      })
      .catch((err) => {
        console.error("error in getting whishlist", err);
      });
    // Fetch
  }, []);

  useEffect(() => {
    loadCategoryProducts();
    loadCategory();
  }, []);

  const loadCategoryProducts = () => {
    listCategoryProducts()
      .then((res) => {
        if (res && res.data) {
          setCategPro(res.data);
        }
      })
      .catch((err) => {
        console.error("Error loading category products", err);
      });
  };
  const loadCategory = () => {
    listCategory()
      .then((res) => {
        if (res && res.data) {
          setCateg(res.data);
        }
      })
      .catch((err) => {
        console.error("Error loading categories", err);
      });
  };

  const hanldeDeletClick = (productid) => {
    const userid = localStorage.getItem("RegisterUserID");

    RemoveFromWhislist({ userid, productid })
      .then((res) => {
        setWishlistList(res.data);
        // setWishListCheck(false);
      })
      .catch((err) => {
        console.error("error ina remove list", err);
      });
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>My Wishlist | Ziya Mangalsutra - Your Favourite Designs</title>
        <meta name="description" content="View and manage your favourite gold and diamond mangalsutra designs. Start your collection with Ziya Mangalsutra." />
        <meta name="keywords" content="mangalsutra wishlist, favourite mangalsutra, ziya collection, save jewellery" />
        <link rel="canonical" href={`${process.env.REACT_APP_API_URL_ZIYA}/whishlistnew`} />
      </Helmet>
      <Header />
      <div id="site-main" className="site-main">
        <div id="main-content" className="main-content">
          <div id="primary" className="content-area">
            <div
              id="title"
              className="page-title page-title-dark title-who-we-are"
            >
              <div className="section-container text-start">
                <div className="content-title-heading">
                  <h1 className="text-title-heading">WISHLIST</h1>
                </div>
                <div className="breadcrumbs">
                  <Link to="/">Home</Link>
                  <span className="delimiter" />
                  WISHLIST
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Container>
        <Row>
          {categPro && WishlistList.length !== 0 ? (
            <>
              {categPro
                .filter((product) =>
                  WishlistList.some(
                    (wishlistItem) => wishlistItem === product._id
                  )
                )
                .map((product) => (
                  <Col lg="4" key={product._id} style={{ marginTop: "15px" }}>
                    <Card
                      className="wishListCard"
                      style={{ width: "100%", height: "auto" }}
                    >
                      <div className="wishListDiv">
                        <div>
                          <Card style={{ width: "150px", height: "160px" }}>
                            <img
                              src={`${process.env.REACT_APP_API_URL_ZIYA}/${product.ProductImage}`}
                              alt={product.ProductName}
                            />
                          </Card>
                        </div>
                        <div>
                          <h1>{product.ProductWeight} g</h1>
                          <p style={{ marginBottom: "0px" }}>
                            {product.ProductDescription}
                          </p>

                          <div className="tryItDivMain">
                            {/* <div className="tryAtBtn">
                              <Link
                                to="#"
                                className="button button-primary animation-horizontal"
                              >
                                TRY IT ON <FaCamera />
                              </Link>
                            </div> */}
                            <div
                              style={{ textAlign: "right", cursor: "pointer" }}
                              className="m-2"
                              onClick={() => {
                                hanldeDeletClick(product._id);
                              }}
                            >
                              <MdDelete className="deleteIcon" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  </Col>
                ))}
            </>
          ) : (
            <>
              <div className="wishListDiv emptyWishlist">
                <h2>Your Wishlist Seems to be Empty!</h2>

                <div className="emptyWishlistBox">
                  <Link to="/the-collection">
                    <h2>Start Exploring</h2>
                  </Link>
                </div>
              </div>
            </>
          )}
        </Row>
      </Container>

      {/* <RangeSlider
        id="range-slider-gradient"
        step={"any"}
        defaultValue={[0, 50]}
        thumbsDisabled={[true, false]}
        rangeSlideDisabled={true}
      /> */}
      <Footer />
    </React.Fragment>
  );
};

export default WIshList;
